import ChevronIcon from '~/assets/icons/Chevron';

type Props = Omit<React.HTMLProps<HTMLSelectElement>, 'defaultValue'> & {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: { displayValue: string; value: string }[];
};

const SelectInput = ({
  id,
  name,
  placeholder,
  required,
  options,
  onChange
}: Props) => {
  const invalidPlaceholderValue = '';

  return (
    <div className="relative w-full">
      <select
        id={id}
        name={name}
        required={required}
        className=" h-12 w-full appearance-none rounded-md border px-2 text-base"
        defaultValue={invalidPlaceholderValue}
        onChange={onChange}
      >
        {placeholder && (
          <>
            <option disabled value={invalidPlaceholderValue}>
              {placeholder}
            </option>
          </>
        )}
        <>
          {options.map(({ value, displayValue }) => (
            <option key={value} value={value}>
              {displayValue}
            </option>
          ))}
        </>
      </select>
      <div className="absolute right-4 top-1/2 -translate-y-1/2">
        <ChevronIcon width="12" height="12" stroke="black" />
      </div>
    </div>
  );
};

export default SelectInput;
